<template>
  <div>
    <silent-box :gallery="images" class="silentbox"></silent-box>
  </div>
</template>

<style>
.silentbox {
  white-space: nowrap;
  overflow-x: auto;
}
.silentbox-item {
  cursor: pointer;
  display: inline-block;
  text-decoration: underline;
  margin: 0 8px 8px 0;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  background: #f5f5f5;
  max-width: 300px;
  height: 200px;
  line-height: 200px;
  overflow: hidden;
  text-align: center;
}
.silentbox-item > img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
.silentbox-is-opened {
  overflow: hidden;
}
#silentbox-overlay {
  display: block;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 999;
}
#silentbox-overlay__background {
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(20px);
  cursor: default;
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
#silentbox-overlay__content {
  cursor: default;
  display: block;
  height: 100%;
  position: relative;
  width: 100%;
}
#silentbox-overlay__embed {
  bottom: 0;
  cursor: default;
  display: block;
  height: 80%;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: -2.5rem;
  width: 75%;
}
#silentbox-overlay__embed img,
#silentbox-overlay__embed iframe {
  background-color: #000;
  bottom: 0;
  box-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.45);
  cursor: default;
  display: block;
  left: 0;
  margin: auto;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
#silentbox-overlay__container {
  cursor: default;
  height: 100%;
  margin: 0 0 1.5rem 0;
  position: relative;
  text-align: center;
  width: 100%;
}
#silentbox-overlay__description {
  display: block;
  padding-top: 1rem;
  text-align: center;
  color: #fff;
}
#silentbox-overlay__close-button {
  background: rgba(0, 0, 0, 0);
  border: none;
  color: #fff;
  cursor: pointer;
  height: 2.5rem;
  position: absolute;
  right: 0;
  top: 0;
  transition: background-color 250ms ease-out;
  width: 2.5rem;
}
#silentbox-overlay__close-button:hover,
#silentbox-overlay__close-button:focus {
  background-color: rgba(0, 0, 0, 0.5);
  outline: none;
}
#silentbox-overlay__close-button .icon {
  color: #fff;
  cursor: pointer;
  height: 1rem;
  left: 0.7rem;
  margin: 50% 50% 0 0;
  position: absolute;
  right: 0px;
  top: -0.5rem;
  transition: 250ms ease;
  width: 1rem;
}
#silentbox-overlay__close-button .icon:before,
#silentbox-overlay__close-button .icon:after {
  background: #fff;
  content: "";
  height: 2px;
  left: 5%;
  position: absolute;
  top: 50%;
  transition: 250ms ease;
  width: 100%;
}
#silentbox-overlay__close-button .icon:before {
  transform: rotate(-45deg);
}
#silentbox-overlay__close-button .icon:after {
  transform: rotate(45deg);
}
#silentbox-overlay__close-button .icon:hover:before,
#silentbox-overlay__close-button .icon:hover:after,
#silentbox-overlay__close-button .icon:focus:before,
#silentbox-overlay__close-button .icon:focus:after {
  background: #58e8d2;
  left: 25%;
  width: 50%;
}
#silentbox-overlay__arrow-buttons .arrow {
  border-left: 2px solid #fff;
  border-top: 2px solid #fff;
  cursor: pointer;
  height: 1.5rem;
  position: absolute;
  width: 1.5rem;
}
#silentbox-overlay__arrow-buttons .arrow:hover,
#silentbox-overlay__arrow-buttons .arrow:focus {
  outline: none;
  border-color: #58e8d2;
}
#silentbox-overlay__arrow-buttons .arrow-previous {
  left: 2rem;
  top: 50%;
  transform: rotate(-45deg);
}
#silentbox-overlay__arrow-buttons .arrow-previous:hover,
#silentbox-overlay__arrow-buttons .arrow-previous:focus {
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-name: pulsingPrevious;
}
#silentbox-overlay__arrow-buttons .arrow-next {
  right: 2rem;
  top: 50%;
  transform: rotate(135deg);
}
#silentbox-overlay__arrow-buttons .arrow-next:hover,
#silentbox-overlay__arrow-buttons .arrow-next:focus {
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-name: pulsingNext;
}
#silentbox-overlay .silentbox-video__frame {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
#silentbox-overlay .silentbox-video__embed {
  outline: none;
}
#silentbox-overlay .silentbox-video__embed:active,
#silentbox-overlay .silentbox-video__embed:focus,
#silentbox-overlay .silentbox-video__embed:hover {
  outline: none;
}
.silentbox-animation__swipe-left-enter-active {
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateX(25vw);
}
.silentbox-animation__swipe-left-leave-active {
  transition: all 0.3s ease;
  transition: opacity 0.5s;
}
.silentbox-animation__swipe-left-enter-to {
  opacity: 1;
  transition: all 0.3s ease;
  transform: translateX(0);
}
.silentbox-animation__swipe-left-leave-to {
  opacity: 0;
  transition: all 0.3s ease;
  transform: translateX(-25vw);
}
.silentbox-animation__swipe-right-enter-active {
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateX(-25vw);
}
.silentbox-animation__swipe-right-leave-active {
  transition: all 0.3s ease;
  transition: opacity 0.5s;
}
.silentbox-animation__swipe-right-enter-to {
  opacity: 1;
  transition: all 0.3s ease;
  transform: translateX(0);
}
.silentbox-animation__swipe-right-leave-to {
  opacity: 0;
  transition: all 0.3s ease;
  transform: translateX(25vw);
}
@keyframes pulsingNext {
  0% {
    animation-timing-function: ease-in;
    right: 2rem;
  }
  25% {
    animation-timing-function: ease-in;
    right: 1.75rem;
  }
  75% {
    animation-timing-function: ease-in;
    right: 2.25rem;
  }
  100% {
    animation-timing-function: ease-in;
    right: 2rem;
  }
}
@keyframes pulsingPrevious {
  0% {
      animation-timing-function: ease-in;
      left: 2rem;
  }
  25% {
      animation-timing-function: ease-in;
      left: 1.75rem;
  }
  75% {
      animation-timing-function: ease-in;
      left: 2.25rem;
  }
  100% {
      animation-timing-function: ease-in;
      left: 2rem;
  }
}
</style>

<script>
import Vue from 'vue';
import VueSilentbox from 'vue-silentbox';

Vue.use(VueSilentbox);

export default {
  name: 'image-gallery',
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
};
</script>
